import { render, staticRenderFns } from "./requestillegal.vue?vue&type=template&id=bde5849e&scoped=true"
import script from "./requestillegal.vue?vue&type=script&lang=js"
export * from "./requestillegal.vue?vue&type=script&lang=js"
import style0 from "./requestillegal.vue?vue&type=style&index=0&id=bde5849e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde5849e",
  null
  
)

export default component.exports